import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnTK: CultureInfo = {
  name: 'en-TK',
  displayName: 'English (Tokelau)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-TK',
  parent: CultureInfoEn
};
